// Admin Auth Action Types
export const ADMIN_AUTH_LOGIN = 'ADMIN_AUTH_LOGIN';
export const ADMIN_AUTH_LOGOUT = 'ADMIN_AUTH_LOGOUT';
export const ADMIN_AUTH_ERROR = 'ADMIN_AUTH_ERROR';
export const ADMIN_AUTH_LOADING = 'ADMIN_AUTH_LOADING';
export const ADMIN_FACEBOOK_CONNECT = 'ADMIN_FACEBOOK_CONNECT';
export const ADMIN_FACEBOOK_DISCONNECT = 'ADMIN_FACEBOOK_DISCONNECT';
